import { render } from "./admin-state.vue?vue&type=template&id=60b41cc1&scoped=true"
import script from "./admin-state.vue?vue&type=script&lang=js"
export * from "./admin-state.vue?vue&type=script&lang=js"

import "./admin-state.vue?vue&type=style&index=0&id=60b41cc1&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b41cc1"],['__file',"src/components/admin-dashboard/ui/admin-state.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60b41cc1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60b41cc1', __exports__)) {
    api.reload('60b41cc1', __exports__)
  }
  
  module.hot.accept("./admin-state.vue?vue&type=template&id=60b41cc1&scoped=true", () => {
    api.rerender('60b41cc1', render)
  })

}


export default __exports__